/* =============================================================================
   Custom theme scripts
   -----------------------------------------------------------------------------
   Layout order:
     1. Global helpers called from inline handlers in Liquid templates
     2. jQuery $(document).ready block
     3. Native DOMContentLoaded block
   ============================================================================= */


/* -----------------------------------------------------------------------------
   1. Global helpers (called from inline onclick="" attributes in Liquid)
   -------------------------------------------------------------------------- */

/* Product page: toggles the truncated description between "Read more" / "Read less". */
function myFunction() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnText = document.getElementById("myBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Read more";
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "Read less";
    moreText.style.display = "inline";
  }
}

/* Account page: shows the requested tab pane and marks its link active. */
function displayContent(event, contentNameID) {
  let content =
      document.getElementsByClassName("AccountTabcontent");
  let totalCount = content.length;

  // Loop through the content class
  // and hide the tabs first
  for (let count = 0;
       count < totalCount; count++) {
    content[count].style.display = "none";
  }

  let links =
      document.getElementsByClassName("linkClass");
  totalLinks = links.length;

  // Loop through the links and
  // remove the active class
  for (let count = 0;
       count < totalLinks; count++) {
    links[count].classList.remove("active");
  }

  // Display the current tab
  document.getElementById(contentNameID)
  .style.display = "block";

  // Add the active class to the current tab
  event.currentTarget.classList.add("active");
}

/* Collection page: shows/hides product cards for the selected colour filters. */
function filterProductsByColors(colors) {
  // Logic to show/hide products based on selected colors
  document.querySelectorAll('.grid__item.product-card').forEach(function(product) {
    var productColorsAttribute = product.getAttribute('data-colors');
    var productColors = productColorsAttribute ? productColorsAttribute.split(',') : [];

    try {
      if (colors.length === 0 || colors.some(color => productColors.includes(color))) {
        product.style.display = 'block';
      } else {
        product.style.display = 'none';
      }
    } catch (error) {
      console.error("Error filtering products:", error);
    }
  });
}


/* -----------------------------------------------------------------------------
   2. jQuery ready
   -------------------------------------------------------------------------- */

$(document).ready(function(){

  /* --- Slick slider init -----------------------------------------------------
     KEEP THIS SELECTOR NARROW. The only element in this theme that is meant to
     be slick-initialised is the announcement slider rendered by
     sections/AnnouncementSlider.liquid, whose markup is
     <div class="slider single-item">.

     Do NOT widen this back to a bare ".slider": the `slider` class is also used
     by stock Dawn components (sections/slideshow.liquid, sections/main-product.liquid,
     snippets/product-thumbnail.liquid). Running slick over those rewrites Dawn's
     own slider DOM and breaks the page - Dawn's inline style block leaks onto the
     page as visible text, a duplicate strip of pager dots appears, and the slide
     images collapse into a large empty region.

     The length check keeps this a no-op on pages without the announcement slider. */
  var $slickSlider = $(".slider.single-item");
  if($slickSlider.length>0){
    $slickSlider.slick({
      draggable: true,
      autoplay: true,
      autoplaySpeed: 7000,
      arrows: true,
      dots: true,
      fade: true,
      speed: 500,
      infinite: true,
      cssEase: 'ease-in-out',
      touchThreshold: 100
    });
  }

  /* --- Header: mark the active sub-menu item and open its parent details --- */
  $('span.header__active-menu-item').parent('a').addClass('w--current');
  $('span.header__active-menu-item').removeClass('header__active-menu-item');
  $('.header__inline-menu a.w--current').parent('summary').parent('details').attr("open","open");

  /* --- Breadcrumbs: prepend the main category ------------------------------ */
  var main_cat_lbl = $('.header__inline-menu a.w--current span').text();
  var main_cat_src = $('.header__inline-menu a.w--current').attr('href');
  $('<li class="breadcrumbs__item"><a class="breadcrumbs__link" href="'+main_cat_src+'">'+main_cat_lbl+'</a></li>').insertBefore('.cat_breadcrumbs__item');
  if($('.cat_breadcrumbs__item2 a.w--current').attr('href')==main_cat_src){
  }else{
    $('<li class="breadcrumbs__item"><a class="breadcrumbs__link" href="'+main_cat_src+'">'+main_cat_lbl+'</a></li>').insertBefore('.cat_breadcrumbs__item2');
  }

  /* --- Announcement slider progress bar ("ticking machine") -----------------
     Drives the progress bars rendered by sections/AnnouncementSlider.liquid,
     whose slider markup is <div class="slider single-item"> (so it is the same
     element slick-initialised above) alongside .progressBarContainer/.progressBar.
     Everything below - including the 30ms interval - only runs when that markup
     is actually present, so no timer is started on pages without the slider. */
  var $announcementSlider = $('.slider.single-item');
  var $progressBars = $('.progressBarContainer .progressBar');

  if ($announcementSlider.length > 0 && $progressBars.length > 0) {
    var percentTime;
    var tick;
    var time = 1;
    var progressBarIndex = 0;

    $progressBars.each(function (index) {
      var progress = "<div class='inProgress inProgress" + index + "'></div>";
      $(this).html(progress);
    });

    var resetProgressbar = function () {
      $('.inProgress').css({
        width: 0 + '%'
      });
      clearInterval(tick);
    };

    var interval = function () {
      if (($announcementSlider.find('.slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
        progressBarIndex = $announcementSlider.find('.slick-track div[aria-hidden="false"]').data("slickIndex");

        if (progressBarIndex == 1) {
          $(".inProgress0").addClass('on');
          $(".inProgress1").removeClass('on');
        }
        else if (progressBarIndex == 0) {
          $(".inProgress0").addClass('on');
          $(".inProgress1").addClass('on');
        }
        startProgressbar();

      } else {
        percentTime += 1 / (time + 2);
        $('.inProgress' + progressBarIndex).css({
          width: percentTime + "%"
        });
        if (percentTime >= 100) {
          $announcementSlider.slick('slickNext');

          if (progressBarIndex == 0) {
            $(".inProgress0").addClass('on');
          }
          else if (progressBarIndex == 1) {
            $(".inProgress0").addClass('on');
            $(".inProgress1").addClass('on');
          }

          progressBarIndex++;

          if (progressBarIndex > 0) {
            progressBarIndex = 0;
          }
          startProgressbar();
        }
      }
    };

    var startProgressbar = function () {
      resetProgressbar();
      percentTime = 0;
      tick = setInterval(interval, 30);
    };

    startProgressbar();

    /* Clicking a progress bar jumps the slider to that slide. */
    $('.progressBarContainer div').click(function () {
      clearInterval(tick);
      var goToThisIndex = $(this).find("span").data("slickIndex");
      $announcementSlider.slick('slickGoTo', goToThisIndex, false);
      startProgressbar();
    });
  }
  /* --- End ticking machine ------------------------------------------------- */

  /* --- Header nav: open the details block matching the current URL --------- */
  var pageurl = window.location.href;

  $(".header__inline-menu ul li.FirstLevelNav").each(function(){
    var navlink = $(this).attr("data-url");
    if (pageurl.indexOf(navlink) > -1) {
      $(this).find(".FirstLevelSummary").trigger( "click" );
      $(this).find(".FirstLevelDetails").attr("open");
      $(this).find(".FirstLevelSummary").attr("aria-expanded","true");
    }else{
      $(".FirstlevelchildDetails").addClass("test");
      $(".FirstlevelchildDetails").attr("open","open");
      $(".FirstlevelchildSummary").attr("aria-expanded","true");
    }
  });

  /* --- Collection page: custom tag filter ---------------------------------
     Marks the filters present in the current URL as active, mirrors the
     mobile <select> onto the filter list, and swaps the product grid over
     AJAX when a filter link is clicked. */
  $(".CollectionFilter-innerUL li").each(function(){
    var filterurlTag = $(this).children("a").attr("href");
    if (window.location.href.indexOf(filterurlTag) > -1) {
      $(this).addClass('filter-added');
    }
    if ($(this).hasClass("filter-added")) {
      $(this).children("a").children(".FilterActive").css('display','block');
      $(this).children("a").children(".FilterunActive").css('display','none');
    }
  });

  $(".selectTypeSec select.SelectBox").on('change', function() {
    var selectOption = $(this).val();
    $(".CollectionFilter-innerUL li.option").each(function(){
      var liOption = $(this).children("a").attr("href");

      if (selectOption.indexOf(liOption) > -1) {
        $(this).children("a").trigger( "click" );
      }
    });
  });

  $(".CollectionFilter-innerUL li a").click(function (e) {
    e.preventDefault();

    if (pageurl.indexOf("?page=2") > -1) {
      var spliturl = pageurl.split("?");
      var collectionurl = spliturl[0];
      var newcollectionurl = collectionurl;
    }else{
      var newcollectionurl = pageurl;
    }

    var updatedValue=" ";
    var parentValue =$(this).parent("li");
    if (parentValue.hasClass("filter-added")){
      parentValue.removeClass('filter-added');
      $(this).children(".FilterActive").css('display','none');
      $(this).children(".FilterunActive").css('display','block');
      var newurl= newcollectionurl;
    }
    else {
      parentValue.addClass('filter-added');
      $(".filter-added").each(function(i){
        var filterValue = $(this).children("a").attr("href");
        if(i==0){
          var NewFilterValue = filterValue;
        }
        else{
          var NewFilterValue = filterValue + "+" + updatedValue ;
        }
        updatedValue = NewFilterValue;
      });
      var newurl= newcollectionurl +"/" + updatedValue;
      $(this).children(".FilterActive").css('display','block');
      $(this).children(".FilterunActive").css('display','none');
    }
    $.ajax({
      type: 'GET',
      url: newurl,
      dataType: 'html',
      success: function(data){
        var FitlterProducts = $(data).find(".ProductListSec").html();
        $(".ProductListSec").html(FitlterProducts);
        history.pushState({
          page: newurl
        }, newurl, newurl);
      }
    });
  });
  /* --- End collection filter ----------------------------------------------- */

  /* --- Account page: order list <-> single order detail, and tab state ----- */
  $(".ViewOrder").click(function(e){
    e.preventDefault();
    $(".OrderListSec").hide();
    var singleorder = $(this).attr("href");
    $.ajax({
      url: singleorder,
      type: 'GET',
      dataType: 'html',
      success: function(data) {
        var OrderData = $(data).find(".CustomerOrderSec").html();
        $(".SingleOrderDetail").show();
        $(".SingleOrderDetail").html(OrderData);
      }
    });
  });

  $('body').on('click', '.BackToOrderListSec', function() {
    $(".OrderListSec").show();
    $(".SingleOrderDetail").hide();
  });

  if (pageurl.indexOf("account/addresses") > -1) {
    $(".AccountTabUlSec li").each(function(){
      if ($(this).hasClass('AddressBookPg')){
        $(this).children('button.linkClass').addClass('active');
        $(this).parent('.AccountTabUlSec').siblings('#address-book').css("display","block");
      } else {
        $(this).children('button.linkClass').removeClass('active');
      }
    });
  }

  $(".AddressBookPg").click(function(){
    var addressPgUrl = $(this).attr("data-AddressUrl");
    if (window.location.href.indexOf(addressPgUrl) > -1) {
    }else{
      window.location.href = addressPgUrl;
    }
  });
  /* --- End account page ---------------------------------------------------- */

  /* --- FAQ page accordion --------------------------------------------------- */
  $('.accordion a').click(function(){
    $(this).toggleClass('active');
    $(this).next('.content').slideToggle(400);
  });

  /* --- Product page: colour swatch click reloads on the chosen variant ------ */
  $('.v_image').click(function(){
    var v_id = $(this).attr('v_image');
    var v_href = window.location.href.split("?");
    window.location.href = v_href[0]+'?variant='+v_id;
  });

  /* --- Product card: hovering a colour swatch swaps the card image/link ---- */
  $('.v_img_list').hover(function() {
    var p_id = $(this).attr('data-product-id');
    var v_img = $(this).attr('data-variant-image');
    var real_img = v_img.replace(/_small./gi, ".");
    var v_link = $(this).attr('href');

    var real_img_set1 = real_img + '&width=165 165w,';
    var real_img_set2 = real_img + '&width=360 360w,';
    var real_img_set3 = real_img + '&width=533 533w,';
    var real_img_set4 = real_img + '&width=720 720w,';
    var real_img_set5 = real_img + '&width=940 940w,';
    var real_img_set6 = real_img + ' 1024w';
    var real_img_set = real_img_set1 + real_img_set2 + real_img_set3 + real_img_set4 + real_img_set5 + real_img_set6;

    $('#v_img_list_'+p_id).attr('src',real_img);
    $('#v_img_list_'+p_id).attr('srcset',real_img_set);

    $('#v_img_list_'+p_id).parent().attr('href',v_link);
  });

  /* --- Collection grid: keep swatch links inside the current collection path - */
  $('#product-grid .grid__item .CollectionProductImage').each(function( index ) {
    var cat_a = $(this).attr('href');
    var cat_a2 = cat_a.split('/products/');

    $('#product-grid .grid__item .product_ColorVariant .colourselectoption .v_img_list').each(function( index ) {
      var prod_a = $(this).attr('href');
      var prod_a2 = prod_a.split("?");
      if(prod_a.indexOf("/collections/")==-1 && ("/products/"+cat_a2[1])==prod_a2[0]){
        $(this).attr('href',cat_a2[0]+prod_a);
      }
    });
  });

  /* --- Quantity steppers: product form ------------------------------------- */
  $('.QuantityAddtoCartSec .quantity__button').click(function(){
    var nm = $(this).attr('name');
    var qt = $('.QuantityAddtoCartSec .quantity__input').val();
    if(nm=='minus'){
      qt = parseInt(qt) - 1;
    }else if(nm=='plus'){
      qt = parseInt(qt) + 1;
    }
    if(qt<=0){
      qt = 1;
    }
    $('.QuantityAddtoCartSec .quantity__input').val(qt);
  });

  /* --- Quantity steppers: cart line items ---------------------------------- */
  $('.cart-item__quantity .quantity__button').click(function(){
    var nm = $(this).attr('name');
    var lb = $(this).parent().parent().parent().parent().attr('id');
    lb = lb.split('-');
    lb = lb[1];
    var qt = $('#Quantity-'+lb).val();
    if(nm=='minus'){
      qt = parseInt(qt) - 1;
    }else if(nm=='plus'){
      qt = parseInt(qt) + 1;
    }
    if(qt<=0){
      qt = 1;
    }
    $('#Quantity-'+lb).val(qt);
  });
});


/* -----------------------------------------------------------------------------
   3. Native DOMContentLoaded
   -------------------------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', function() {

  /* --- Product card: show the hovered colour's name ------------------------ */
  document.querySelectorAll('.product_ColorVariant').forEach(productVariant => {
    let firstColorLabel = productVariant.querySelector('.colourselectoption .color-name-label');

    if (firstColorLabel) {
      let colorName = firstColorLabel.textContent;
      let colorNameDisplay = productVariant.querySelector('.color-name-display');
      colorNameDisplay.textContent = colorName;
    }

    productVariant.querySelectorAll('.colourselectoption').forEach(item => {
      item.addEventListener('mouseenter', function() {
        var colorValue = this.querySelector('.color-name-label').textContent;
        var colorNameDisplay = productVariant.querySelector('.color-name-display');
        colorNameDisplay.textContent = colorValue;
      });
    });
  });

  /* --- Product card: move the swatch underline to the hovered swatch ------- */
  document.querySelectorAll('.product_ColorVariant').forEach(variant => {
    const swatches = variant.querySelectorAll('.colourselectoption');

    const defaultSwatch = variant.querySelector('.default-swatch');
    if (defaultSwatch) {
      defaultSwatch.classList.add('line-above-swatch');
    }

    swatches.forEach(swatch => {
      swatch.addEventListener('mouseenter', function() {
        swatches.forEach(el => el.classList.remove('line-above-swatch', 'default-swatch'));

        this.classList.add('line-above-swatch');
      });
    });
  });

  /* --- Collection page: colour filter buttons ------------------------------ */
  var filterButtons = document.querySelectorAll('.filtercolorbutton');
  var selectedColors = []; // Array to store selected colors

  filterButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      var filterColor = this.getAttribute('data-filter-color');

      // Toggle active class on the clicked button
      this.classList.toggle('active');

      // Update selectedColors array based on button state
      if (this.classList.contains('active')) {
        selectedColors.push(filterColor);
      } else {
        selectedColors = selectedColors.filter(function(color) {
          return color !== filterColor;
        });
      }

      // Filter products based on selected colors
      filterProductsByColors(selectedColors);
    });
  });

  /* --- Header: hide the first menu list while another top-level menu is used
     These IDs are generated per top-level menu item, so any of them can be
     absent depending on how many items the menu has - guard every lookup. */
  var triggerElement2 = document.getElementById('Details-HeaderMenu-2');
  var triggerElement3 = document.getElementById('Details-HeaderMenu-3');
  var targetElement = document.getElementById('HeaderMenu-MenuList-1');
  let menuItems = document.querySelectorAll('#HeaderMenu-MenuList-2 li');

  // Function to toggle the target element's display
  function toggleDisplay() {
    if (!targetElement) return;
    if (targetElement.style.display !== 'none') {
      targetElement.style.display = 'none';
    } else {
      targetElement.style.display = '';
    }
  }

  // Add click event listeners to the trigger elements
  if (triggerElement2) triggerElement2.addEventListener('click', toggleDisplay);
  if (triggerElement3) triggerElement3.addEventListener('click', toggleDisplay);

  // Add click event listeners to menu items
  menuItems.forEach(item => {
    item.addEventListener('click', toggleDisplay);
  });

  /* --- Header: close the first menu whenever menu 2 or 3 is open ----------- */
  var targetElementSelector1 = '#Details-HeaderMenu-1';
  var isOpenSelector2 = '#Details-HeaderMenu-2[open="open"]';
  var isOpenSelector3 = '#Details-HeaderMenu-3[open="open"]';
  var menuItemsSelector = '#HeaderMenu-MenuList-2 li';

  function removeOpenAttribute(selector) {
    var targetElement = document.querySelector(targetElementSelector1);
    var isOpen = document.querySelector(selector);
    if (isOpen && targetElement && targetElement.hasAttribute('open')) {
      targetElement.removeAttribute('open');
    }
  }

  function checkAndToggle() {
    removeOpenAttribute(isOpenSelector2);
    removeOpenAttribute(isOpenSelector3);
  }

  checkAndToggle();

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        checkAndToggle();
      }
    });
  });

  var config = { childList: true, subtree: true };

  observer.observe(document.body, config);

  var observedMenuItems = document.querySelectorAll(menuItemsSelector);
  observedMenuItems.forEach(function(item) {
    item.addEventListener('click', checkAndToggle);
  });
});
